module.exports = __webpack_public_path__ + "static/img/selectLocation.2cd4b3f9.png";